import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=0a20d8e2&scoped=true&"
import script from "./Cart.vue?vue&type=script&lang=js&"
export * from "./Cart.vue?vue&type=script&lang=js&"
import style0 from "./Cart.vue?vue&type=style&index=0&id=0a20d8e2&prod&lang=scss&"
import style1 from "./Cart.vue?vue&type=style&index=1&id=0a20d8e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20d8e2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconClose: require('/opt/build/repo/components/icons/IconClose.vue').default,IconInfo: require('/opt/build/repo/components/icons/IconInfo.vue').default,CartItem: require('/opt/build/repo/components/order/CartItem.vue').default,IconAdd: require('/opt/build/repo/components/icons/IconAdd.vue').default,CartPromo: require('/opt/build/repo/components/order/CartPromo.vue').default,CartOffers: require('/opt/build/repo/components/order/CartOffers.vue').default,CartUpsells: require('/opt/build/repo/components/order/CartUpsells.vue').default})
